module.exports = [{
      plugin: require('/Users/jbritton/Code/projects/fluid-plumbing-website/node_modules/gatsby-plugin-google-gtag/gatsby-browser'),
      options: {"plugins":[],"trackingIds":["UA-151533098-1"],"gtagConfig":{"anonymize_ip":false,"cookie_expires":0,"send_page_view":true},"pluginConfig":{"head":false,"exclude":[]}},
    },{
      plugin: require('/Users/jbritton/Code/projects/fluid-plumbing-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
